import { HelpContent } from '../../../UI-Lib/Help-Tooltip';

export const LONG_RUNNING_PROCESS_SYNTHETIC_HELP: HelpContent[] = [
    {
        helpContentId: 'long-running-process-synthetic.test',
        tooltipText: 'Test the service by simulating long-running processes.'
    }
];
